import TableList from './TableList';

export default {
  TableList,
};
